import React from "react";
import { useTranslation } from "react-i18next";

import { SelectOptions } from "../../../assets/data/options";
import { SkillInputTypeUnion, SkillTypeIntersection } from "../../../store/user/types";
import { SubformProps } from "../../SubformProps";
import { InputFieldPropsUnion } from "../elements/types";
import { KeyUndefinedError, SelectFieldInternal } from "./InputField";

type SkillFieldDescriptor = {
  [key in keyof InputFieldPropsUnion]: any;
}

type Predefined =
  | 'type'

export type SkillInputTypeKey = keyof Omit<SkillInputTypeUnion, Predefined>;

type SkillFieldProps = SubformProps<SkillTypeIntersection> & Partial<SkillFieldDescriptor> & {
  id: SkillInputTypeKey;
  noLabels?: boolean;
}

export const SkillField = (props: SkillFieldProps) : JSX.Element | null => {
  const id = props.id as SkillInputTypeKey;

  // Hooks

  const { t } = useTranslation();

  // Building Component

  switch (id) {
    case "hasKnowledge": {
      return (
        <SelectFieldInternal
          label={t("Do you have knowledge of investments?")}
          placeholder={t("Select...")}
          options={SelectOptions().yesNo}
          { ...props }
        />
      );
    }
    case "level": {
      return (
        <SelectFieldInternal
          label={t("Experience")}
          placeholder={t("Select...")}
          options={SelectOptions().experience}
          { ...props }
        />
      );
    }
    default: {
      KeyUndefinedError(id); // Compile-time check for unhandled cases
    }
  }

  return <></>;
}
